import { formatSalesOrderNumber } from '@zspace/format';
import { SalesOrdersTableRow } from '@zspace/types';
import { formatDateToLocaleString, formatExpiresAt } from '../../shared/utils';
import Link from '../../ui/link/link';
import { Column } from '../../ui/table/types';

const userDetailsSalesOrderDetailsColumns: Column<SalesOrdersTableRow>[] = [
  {
    key: 'number',
    className: 'is-width-15',
    render: (el) => (
      <Link to={`/sales-orders/${el.id}`}>
        {formatSalesOrderNumber(el.number)}
      </Link>
    ),
    title: 'Sales Order',
    sortable: true,
  },
  {
    key: 'opportunity.name',
    className: 'is-width-50',
    render: (el) => el.opportunity?.name,
    title: 'Opportunity name',
    sortable: true,
  },
  {
    key: 'closeDate',
    className: 'is-width-10',
    render: (el) =>
      el.closeDate ? formatDateToLocaleString(el.closeDate) : '',
    title: 'Close date',
    sortable: true,
  },
  {
    key: 'permissionsGroupUserRoleAssignments.permissionsGroup.name',
    className: 'is-width-20',
    render: (el) =>
      el.permissionsGroupUserRoleAssignments
        ?.reduce((acc, item) => {
          acc.push(item.permissionsGroup.name);
          return acc;
        }, [] as string[])
        .join(', '),
    title: 'Permissions',
    sortable: false,
  },
  {
    key: 'permissionsGroupUserRoleAssignments.expiresAt',
    className: 'is-width-5',
    render: (el) =>
      el.permissionsGroupUserRoleAssignments
        ?.reduce((acc, item) => {
          if (item.expiresAt) acc.push(formatExpiresAt(item.expiresAt));
          return acc;
        }, [] as string[])
        .join(', '),
    title: 'Remaining Days',
    sortable: true,
  },
];

export { userDetailsSalesOrderDetailsColumns };
